import React from 'react';
import ReactMarkdown from 'react-markdown';

export default function Markdown({ markdown }) {
  return (
    <ReactMarkdown linkTarget="blank">
      {markdown?.replace(/\n/gi, '\n &nbsp;')}
    </ReactMarkdown>
  );
}
